import {Directive, ElementRef, AfterViewInit} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appTimePicker]'
})
export class TimePickerDirective implements AfterViewInit {

    private _element: any;

    constructor(el: ElementRef) {
        this._element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this._element.AnyTime_picker({
            format: '%H:%i'
        });
    }

}
